<style lang="scss" scoped>
.dropmenu {
    position: absolute;
    z-index: 9;
    left: 0;
    top: 0;
    padding-top: 10px;
    margin-top: 20px;
    // display: none;
    .dropmenu-content {
        padding: 0;
        width: 278px;
        height: 122px;
        border-radius: 2px;
        background-color: white;
        box-shadow: 2px 2px 9px rgba(0, 0, 0, 0.5);
    }
    .content {
        height: 88px;
        padding: 20px 17px;
        border-bottom: 1px solid #e8e8e8;
        color: #505060;
        font-size: 13px;
        cursor: default;
        h2,
        p {
            margin: 0;
            max-width: 200px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
        h2 {
            color: black;
            font-size: 17px;
            margin-bottom: 14px;
        }
    }
    .footer {
        font-size: 0;
        height: 34px;
        a {
            text-align: center;
            display: inline-block;
            width: 50%;
            font-size: 12px;
            height: 100%;
            line-height: 34px;
            color: #505060;
            border-right: 1px solid #ddd;
            &:hover {
                background-color: #f3f3f3;
            }
            &:last-child {
                border-right: 0;
            }
        }
        .more {
            position: relative;
            &:hover {
                .menu-list {
                    display: block;
                }
            }
            .menu-list {
                position: absolute;
                display: none;
                top: 34px;
                width: 100%;
                background-color: white;
                border-bottom-left-radius: 2px;
                border-bottom-right-radius: 2px;
                box-shadow: 2px 2px 9px rgba(0, 0, 0, 0.2);
                li {
                    height: 28px;
                    line-height: 28px;
                    &:hover {
                        background-color: #f3f3f3;
                    }
                }
            }
        }
    }
    .op {
        position: absolute;
        right: 20px;
        top: 35px;
        a {
            color: #84848b;
            font-size: 12px;
            display: block;
            margin-bottom: 16px;
            text-decoration: underline;
        }
    }
}
</style>

<template>
    <div class="dropmenu" :style="ddStyle">
        <div class="dropmenu-content">
            <div class="content">
                <h2>{{info.nickname}}</h2>
                <p>{{info.email}}</p>
                <div class="op">
                    <router-link :to="{name: 'write', params: {addr: [info.email]}}" tag="a">写信</router-link>
                    <a href="javascript:;" v-clipboard:copy="info.email" v-clipboard:success="onCopy">复制</a>
                </div>
            </div>
            <div class="footer">
                <a href="javascript:;" @click="addToContact">{{this.userId ? '编辑' : '添加'}}联系人</a>
                <a href="javascript:;" class="more">更多
                    <i class="icons icon-more-big"></i>
                    <ul class="menu-list">
                        <li @click="reject">拒收该邮件</li>
                        <!-- <li>拒收该邮件</li> -->
                    </ul>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { addBlackBulk } from '@/service/whiteblackService'
export default {
    name: 'dropmenu',
    props: ['address'],
    computed: {
        ...mapState({
            contact: state => state.contact
        })
    },
    data() {
        return {
            info: {},
            userId: '',
            ddStyle:{}
        }
    },
    methods: {
        init() {
            let rect= this.$el.parentNode.getBoundingClientRect()
            this.ddStyle.position='fixed'
            this.ddStyle.top=rect.top+'px'
            // this.ddStyle.left=rect.left+'px'
            this.ddStyle.left=rect.right-278+'px'            
            this.info = this.getAddressInfo()
            this.userId = this.getCurrentUserId()
        },
        onCopy() {
            this.$toast({
                message: '复制成功',
                theme: 'success'
            })
        },
        reject() {
            addBlackBulk(this.info.email, 1).then(res => {
                if (res.status === 200) {
                    this.$toast({
                        theme: 'success',
                        message: '设置成功'
                    })
                    return
                }
                this.$toast({
                    theme: 'danger',
                    message: '设置失败'
                })
            })
        },
        addToContact() {
            let self = this
            this.$addAddr({
                email: this.info.email,
                nickname: this.info.nickname,
                gid: this.userId,
                title: this.userId ? '编辑' : '新建',
                success() {
                    self.$emit('update')
                }
            })
        },
        getCurrentUserId() {
            let contact = this.contact.all.contact
            for (let addr of contact) {
                if (this.info.email === addr.email) {
                    return addr.id
                }
            }
            return
        },
        getAddressInfo() {
            let addr = this.address.match(/((.*)<)?(.+@[0-9a-zA-Z-.]+)*>?/),
                nickname = '',
                email = ''
            try {
                email = addr[3]
                nickname = addr[2] ? addr[2] : email.split('@')[0]
            } catch (err) {
                email = this.address
                nickname = this.address('@')[0]
            }
            return { nickname, email }
        }
    },
    mounted() {
        this.init()
    },
    watch: {
        contact() {
            this.init()
        },
        address() {
            this.init()
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/dropdown/dropmenu.vue